module.exports = {"410571563":"开发区峨嵋大街街道","410571564":"开发区银杏大街街道","410571565":"开发区商颂大街街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410571.json
// module id = 1574
// module chunks = 0